



























































































import SimpleMap from '../../core/components/SimpleMap.vue';
import ModalVehicleSettings from './ModalVehicleSettings.vue';
import ModalSetVehicleCalibrationFactor from './ModalSetVehicleCalibrationFactor.vue';

import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getDateFromTimestamp,
    getIdsFromList,
    removeItemsFromList,
    matchedIndexIdInArray,
    getUniqueId,
    formatDate,
    downloadFile,
    getDateFromDateFormatApi
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import DatePickerSingle from '../../core/components/DatePickerSingle.vue';
import DatePickerRange from '../../core/components/DatePickerRange.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import Button from '../../core/components/Button.vue';
import {
    booleanFormatter,
    formatList,
    formattedDate,
    getOnlyDateFromTimestamp,
    nullFormatter
} from '../../core/utils/table-formatters';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import {
    MsgBox,
    Combobox,
    LoadingDialog,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import ModalManualFactor from './ModalManualFactor.vue';
import ModalVehicleCalibration from './ModalVehicleCalibration.vue';
import { config } from 'rxjs';
import moment from 'moment';
import { set } from 'tiny-cookie';

@Component({
    components: {
        Loading,
        Combobox,
        SimpleMap,
        DatePickerSingle,
        DatePickerRange,
        Button,
        SimpleTable,
        ModalManualFactor,
        DeleteConfirmation,
        ModalVehicleSettings,
        ModalSetVehicleCalibrationFactor
    }
})
export default class CardVehicleSettings extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({
        default() {
            return [];
        }
    })
    itemsSettings: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    vehicleVariables: Array<object>;
    @Prop({ default: {} }) patchData: object | null;
    @Prop({ default: false }) isSowing: boolean;
    @Prop({ default: false }) seeAll: boolean;
    @Prop({ default: false }) disabledRow: boolean;
    @Prop({ default: false }) saveOnMemory: boolean; //esta opcion es para almacenar los cambios en memoria sin hacer post ni patch
    @Prop() vehicleID: number | null;
    patchSetting: object | null = {};
    manualFactorToDelete: object | null = null;
    loadingTable: boolean = false;
    viewAllType: string = '';
    configToDelete: object = {};
    visibleModalSettings: boolean = false;
    loadingSettings: boolean = false;
    deleteType: string = '';
    headersSettings: Array<object> = [
        {
            text: 'Fecha',
            align: 'left',
            value: 'configuration_date',
            formatter: getOnlyDateFromTimestamp
        },
        {
            text: 'Ancho trabajo',
            align: 'center',
            value: 'work_width'
        },
        {
            text: 'RTK',
            align: 'center',
            value: 'has_rtk',
            formatter: booleanFormatter
        },
        {
            text: 'Var. Trabajo',
            align: 'left',
            value: 'work_variable',
            formatter: this.variableFormatter
        },
        {
            text: 'Var. Ignoradas',
            align: 'left',
            value: 'blacklisted_variables',
            formatter: this.formatBlacklistedVars
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions'
        }
    ];

    formatBlacklistedVars(list){
        if(list.length  > 0){
            return list.map(function(item) {
                return item['variable_id'] + ' - ' + item['description'];
            }).join(', ');
        }
        return '-'
    }

    get isCarrier(): boolean {
        return this.$_getPrivileges[PRIVILEGE_KEYS.INSURANCE_CARRIER];
    }

    variableFormatter(item) {
        if (item !== null) {
            let varDescription = item['description'] !== null ? item['description'] : '';
            return item['variable_id'] + ' - ' + varDescription;
        } else {
            return '-';
        }
    }

    visibleModalViewAll: boolean = false;
    visibleModalVehicleCalibrationFactor: boolean = false;

    //delete confirmation
    confirmationDelete: boolean = false;
    loadingIgnoredPeriods: boolean = false;
    deleteModalTitle: string = '';
    deleteBody: string = '';

    get getVehicleID() {
        if (this.patchData !== null) {
            return this.patchData['vehicle'] && this.patchData['vehicle']['id']
                ? this.patchData['vehicle']['id']
                : null;
        }
        return null;
    }

    editSetting(item) {
        this.$set(item, 'isLoading', true);

        this.patchSetting = item;

        this.visibilityModalSettings(true);
        this.$set(item, 'isLoading', false);
    }

    deleteConfiguration(configToDelete) {
        this.configToDelete = configToDelete;
        this.setDeleteType('config');
        this.showDeleteConfirmationDialog(
            'Eliminar Configuración',
            '¿Está seguro que desea eliminar esta configuración?'
        );
    }

    updateSetting(updatedSetting) {
        this.loadingSettings = true;
        let indexIdToPatch = matchedIndexIdInArray(this.itemsSettings, updatedSetting['id']);
        if (indexIdToPatch !== -1) {
            this.$set(this.itemsSettings[indexIdToPatch], 'configuration_date', updatedSetting['configuration_date']);
            this.$set(this.itemsSettings[indexIdToPatch], 'encased', updatedSetting['encased']);
            this.$set(this.itemsSettings[indexIdToPatch], 'has_rtk', updatedSetting['has_rtk']);
            this.$set(this.itemsSettings[indexIdToPatch], 'work_variable', updatedSetting['work_variable']);
            this.$set(this.itemsSettings[indexIdToPatch], 'blacklisted_variables', updatedSetting['blacklisted_variables']);
            // this.$set(this.itemsSettings[indexIdToPatch], 'work_variable_delay', updatedSetting['work_variable_delay']);
            this.$set(this.itemsSettings[indexIdToPatch], 'work_width', updatedSetting['work_width']);
            this.$set(this.itemsSettings[indexIdToPatch], 'forced_no_telemetry', updatedSetting['forced_no_telemetry']);
        }
        this.reloadViewAllModalDetail();
        this.loadingSettings = false;
    }

    setDeleteType(value) {
        this.deleteType = value;
    }

    pendingTable(value) {
        this.loadingTable = value;
    }

    @Emit()
    addNewManualFactorToList(item) {
        return item;
    }

    @Emit()
    viewAllConfigurations(item) {}

    @Emit()
    disabledConfigurationRow(item) {}

    @Emit()
    reloadViewAllModalDetail() {}
    @Emit()
    reloadPreviousList() {}

    visibilityModalViewAll(value) {
        this.visibleModalViewAll = value;
    }

    @Emit()
    updateManualFactorInList(item) {
        return item;
    }

    visibilityModalSettings(value) {
        this.visibleModalSettings = value;
    }
    visibilityModalVehicleCalibrationFactor(value) {
        this.visibleModalVehicleCalibrationFactor = value;
    }

    // closeModalManualFactor() {
    //     this.patchSetting = null;
    //     this.manualFactorToDelete = null;
    //     this.visibilityModalSettings(false);
    // }

    clickAddNewSetting() {
        this.visibilityModalSettings(true);
        this.patchSetting = null;
    }

    addNewSetting(newSetting) {
        this.loadingSettings = true;
        let oldItems = this.itemsSettings;
        this.itemsSettings = [];
        oldItems.push(newSetting);
        this.reloadPreviousList();

        setTimeout(() => {
            this.itemsSettings = oldItems;
            this.loadingSettings = false;
        }, 1000);
    }

    editManualFactor(item) {
        this.patchSetting = item;
        this.visibilityModalSettings(true);
    }

    deleteManualFactor(item) {
        this.manualFactorToDelete = item;

        this.showDeleteConfirmationDialog(
            'Eliminar factor manual',
            '¿Está seguro que desea eliminar este factor manual'
        );
    }

    deleteAction(value) {
        if (value) {
            this.confirmationDelete = false;
            this.removeConfiguration();
        } else {
            this.confirmationDelete = false;
        }
    }

    removeConfiguration() {
        let self = this;
        this.loadingSettings = true;

        if (this.saveOnMemory) {
            self.itemsSettings = removeItemsFromList(self.itemsSettings, [self.configToDelete], 'id');
            self.loadingSettings = false;
        } else {
            InsuranceServices.deleteConfiguration(this.configToDelete['id'])
                .then(response => {
                    let msg = '';
                    if (response && response.message) {
                        msg = response.message;
                    } else {
                        msg = 'Configuración Eliminada con éxito';
                    }
                    self.$_successDeleteRecipients(msg);
                    self.itemsSettings = removeItemsFromList(self.itemsSettings, [self.configToDelete], 'id');
                    self.loadingSettings = false;
                    self.reloadPreviousList();
                    self.reloadViewAllModalDetail();
                })
                .catch(error => {
                    this.showMsgError(error);
                    self.loadingSettings = false;
                });
        }
    }

    removeFactorFromList() {
        this.$emit('remove-item-from-list', this.manualFactorToDelete);
    }

    showMsgError(error) {
        let self = this;
        let msg = '';
        if (error && error.response && error.response.data && error.response.data.message) {
            msg = error.response.data.message;
        } else {
            msg = 'Ocurrió un error';
        }
        this.$_errorAddFilter(msg);
    }

    showDeleteConfirmationDialog(title, msgBody) {
        this.deleteModalTitle = title;
        this.deleteBody = msgBody;
        this.confirmationDelete = true;
    }

    dateFormatter(value) {
        return formattedDate(value);
    }

    formatBoolean(value) {
        return booleanFormatter(value);
    }
}
